<template>

    <div class="auth-popup-content">
        <component :is="component"
                   :title="sent ? '' : 'quote.login.title'"
                   button-key="start"
                   phone-disabled
                   @sent="nextView"
                   @unsent="sent = false"
                   v-model="form"></component>
    </div>

</template>

<script>
    import AppAuthLogin from "./Login";
    import AppAuthCode from "./Code";

    export default {
        name: 'app-auth-popup',

        props: {
            phoneNumber: String,
            quoteType: String
        },

        data() {
            return {
                sent: false,

                form: {
                    idNumber: '',
                    phoneNumber: this.phoneNumber,
                    code: '',
                    quoteType: window.yna.quoteType,
                    quoteRequestId: window.yna.quoteRequestId,
                }
            }
        },

        methods: {

            nextView() {
                if(! this.sent) {
                    this.sent = true;
                    return;
                }

                this.$emit('close');
            }

        },

        computed: {
            component() {
                return this.sent ? 'app-auth-code' : 'app-auth-login';
            }
        },

        components: {AppAuthCode, AppAuthLogin},
    }

</script>

<style lang="scss">

    .auth-popup-content {
        flex-grow: 1;
        flex-shrink: 1;
        height: 100%;
        width: 100%;
        max-width: 864px;
        max-height: 621px;
        border-radius: 69px;
        background-color: $white;
        position: relative;
        z-index: 5;
        padding: 20px 0;
        .form-row{
            @media screen and (max-width: $mobile) {
              display: block;
            }

        }
        .form-error {
            margin: 0 25px 25px;
        }

        .description-message {
            font-size: 16px;
            font-weight: bold;
            line-height: 1.3;
            color: $black;
            text-align: center;
            margin: 50px 0;
        }

        .card-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 25px;

            .icon {
                svg {
                    display: block;
                }
            }

            .title {
                font-size: 25px;
                font-weight: bold;
                line-height: 1.32;
                color: $black;
                margin-top: 20px;
            }

        }

    }
</style>
